export const SET_PROJECTS = 'SET_PROJECTS';
export const SET_PROJECT = 'SET_PROJECT';
export const ADD_PROJECT = 'ADD_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const REMOVE_PROJECT = 'REMOVE_PROJECT';
export const CLEAR_PROJECT = 'CLEAR_PROJECT';
export const CLEAR_PROJECTS = 'CLEAR_PROJECTS';
